// export { default } from "../components/OurStoryPage/OurStoryPage.jsx";
// Gatsby Build Fails when using export { default } syntax
// https://github.com/gatsbyjs/gatsby/issues/12384
import OurStoryPage from "../components/OurStoryPage/OurStoryPage.jsx";
export default OurStoryPage;
